export enum PastContactsTableSortColumn {
  COMM_ID = 'contactId',
  TIME = 'dateAndTime',
  CHANNEL_NAME = 'channel',
  CALL_DURATION_SECONDS = 'duration',
  SIC_NODE_1_NAME = 'sic',
  OWNERSHIP_TYPE = 'ownership',
}

export enum PastContactsTab {
  ALL = 'all',
  BOOKMARKED = 'bookmarked',
}

export const PastContactsTableEmptyStateDataTestIds: string =
  'csa-past-contacts-empty-state';

export enum Ownership {
  ALL = 'All',
  MARKED_SPAM = 'Marked Spam',
  MARKED_DUPLICATE = 'Marked Duplicate',
  CONSULTED = 'Consulted',
  TRANSFERED = 'Transferred',
  CHAT_DROPPED = 'Chat Dropped',
  PARKED = 'Parked',
  RESOLVED = 'Resolved',
  UNKNOWN = 'Unknown',
}
